module.exports = __webpack_public_path__ + "img/lk-double-down.0dde9c2d.svg";